import * as TutorialAPI from 'api/tutorial';
import { delayed } from 'lib/Job';
import { call, put, select } from 'redux-saga/effects';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { getIsAuthenticated } from 'store/login';
import { actionCreators as tutorialAC } from 'store/tutorial';

let areLoadTutorialsInitiated: boolean = false;

export function* loadTutorials() {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	try {
		const isAuthenticated = yield select(getIsAuthenticated);

		if (!isAuthenticated) {
			return;
		}

		if (areLoadTutorialsInitiated) {
			return;
		}

		areLoadTutorialsInitiated = true;

		const tutorials = yield call(TutorialAPI.getTutorials as any);
		yield put(tutorialAC.doLoadTutorialsSuccess(tutorials));
	} catch (e) {
		yield put(tutorialAC.doLoadTutorialsFailure({}));
	}
}

export function* resolveTutorial(action: any) {
	try {
		yield put(tutorialAC.doUpdateTutorialFlagInstantly(action.flag, action.value));
		yield call(TutorialAPI.resolveTutorial, { flag: action.flag });
		yield put(tutorialAC.doUpdateTutorialFlagSuccess(action.flag, action.value));
	} catch (e) {
		yield put(tutorialAC.doUpdateTutorialFlagFailure({}));
	}
}

export function* triggerTutorial(action: any) {
	try {
		yield new Promise((resolve: Function) => {
			delayed(resolve, action.delay);
		});
		yield put(tutorialAC.doTriggerTutorialDelayed(action.flag, action.options));
	} catch (e) {
		yield put(tutorialAC.doUnTriggerTutorial());
	}
}
